// @flow

import * as types from '../actionTypes';
import type { userType } from '../../types';
import genericSingletonReducer, {
  genericSingletonSelectorSet,
  useGenericSingleton,
} from './genericSingleton';
import { user } from '../schemata';

const userReducer = genericSingletonReducer(types.GET_USER_ASYNC);

export default userReducer;

export const selectUser = genericSingletonSelectorSet<userType>(
  user,
  state => state.user,
);

export const useUser = useGenericSingleton<userType>(user, state => state.user);
